export default "__VITE_ASSET__COduNELO__"